import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.initSplide();
  }

  initSplide() {
    const splideElement = this.element.querySelector('.image-slider');
    
    if (splideElement) {
      const splide = new Splide('.image-slider', {
        perPage: 2,
        type: 'loop',
        pagination: false,
        speed: 860,
        arrows: false,
        autoWidth: true,
        lazyLoad: 'nearby',
        drag: false, // Disable free dragging to prevent position conflicts
        padding: { right: 0, left: 0 },
        gap: '0.5rem',
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)', // Smooth easing function
        focus: 'center', // Ensures consistent positioning
        fixedWidth: false, // Let the slides adapt to container
        trimSpace: false, // Don't trim spaces to ensure smooth looping
        autoScroll: {
          speed: 0.75,
          pauseOnHover: false,
          rewind: false, // Prevent rewinding that can cause jumps
          smooth: true, // Enable smooth scrolling
        },
        mediaQuery: 'min',
        breakpoints: {
          700: {
            perPage: 3,
          },
          1024: {
            perPage: 4,
          },
          1280: {
            perPage: 6,
            autoScroll: {
              speed: 1,
              smooth: true,
            },
          },
        }
      });

      splide.on('ready', function() {
        splideElement.classList.add('is-active');
      });

      splide.mount(window.splide.Extensions);
    }
  }
}
